/* Localized predictive search; prices are already in the Shopify market currency. */
(function () {
  'use strict';
  const menu = document.getElementById('MobileMegaMenu');
  if (!menu || menu.dataset.searchInitialized) return;
  const input = menu.querySelector('#mmm-search-input');
  const results = menu.querySelector('#mmm-search-results');
  if (!input || !results) return;
  menu.dataset.searchInitialized = 'true';
  const copy = {
    fr: ['Rechercher un modèle…', 'Produits', 'Voir tous les résultats', 'Aucun résultat pour', 'Recherche…', 'Voir la page de recherche', 'À partir de'],
    en: ['Search for a style…', 'Products', 'View all results', 'No results for', 'Searching…', 'Open search results', 'From'],
    de: ['Nach einem Modell suchen…', 'Produkte', 'Alle Ergebnisse anzeigen', 'Keine Ergebnisse für', 'Suche läuft…', 'Suchergebnisse öffnen', 'Ab'],
    nl: ['Zoek een model…', 'Producten', 'Alle resultaten bekijken', 'Geen resultaten voor', 'Zoeken…', 'Zoekresultaten openen', 'Vanaf'],
    it: ['Cerca un modello…', 'Prodotti', 'Vedi tutti i risultati', 'Nessun risultato per', 'Ricerca…', 'Apri i risultati di ricerca', 'Da'],
    da: ['Søg efter en model…', 'Produkter', 'Se alle resultater', 'Ingen resultater for', 'Søger…', 'Åbn søgeresultater', 'Fra'],
    nb: ['Søk etter en modell…', 'Produkter', 'Se alle resultater', 'Ingen resultater for', 'Søker…', 'Åpne søkeresultatene', 'Fra'],
    fi: ['Hae mallia…', 'Tuotteet', 'Näytä kaikki tulokset', 'Ei tuloksia haulle', 'Haetaan…', 'Avaa hakutulokset', 'Alkaen'],
    sv: ['Sök efter en modell…', 'Produkter', 'Visa alla resultat', 'Inga resultat för', 'Söker…', 'Öppna sökresultaten', 'Från']/* nk-propre */,
    es: ['Busca un modelo…', 'Productos', 'Ver todos los resultados', 'Sin resultados para', 'Buscando…', 'Abrir los resultados de búsqueda', 'Desde']/* /nk-propre */
  };
  const language = (menu.dataset.locale || document.documentElement.lang || 'en').split('-')[0];
  const labels = copy[language] || copy.en;
  const currency = menu.dataset.currency;
  const route = (menu.dataset.route || '/').replace(/\/?$/, '/');
  let formatter;
  try { formatter = new Intl.NumberFormat(menu.dataset.locale || language, { style: 'currency', currency }); } catch (_) {}
  input.placeholder = labels[0];
  input.setAttribute('aria-label', labels[0]);
  input.setAttribute('aria-controls', results.id);
  input.setAttribute('aria-expanded', 'false');
  results.setAttribute('aria-label', labels[1]);
  const form = input.closest('form');
  if (form && !form.querySelector('[name="type"]')) {
    const type = document.createElement('input');
    type.type = 'hidden'; type.name = 'type'; type.value = 'product'; form.append(type);
  }
  let timer, controller, requestId = 0;
  function element(tag, className, text) {
    const node = document.createElement(tag);
    node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }
  function visible(on) {
    results.style.display = on ? 'block' : 'none';
    input.setAttribute('aria-expanded', String(on));
  }
  function allResults(query, label) {
    const link = element('a', 'mmm-sr-viewall', label);
    link.href = route + 'search?type=product&q=' + encodeURIComponent(query);
    return link;
  }
  function amount(value) {
    if (value == null || value === '' || !Number.isFinite(Number(value))) return null;
    return Number(value);
  }
  function render(products, query) {
    const fragment = document.createDocumentFragment();
    fragment.append(element('div', products.length ? 'mmm-sr-header' : 'mmm-sr-empty', products.length ? labels[1] : labels[3] + ' « ' + query + ' »'));
    products.forEach(product => {
      let url;
      try { url = new URL(product.url, location.origin); } catch (_) { return; }
      if (url.origin !== location.origin) return;
      const link = element('a', 'mmm-sr-item'); link.href = url.href;
      const source = typeof product.image === 'string' && product.image ? product.image : product.featured_image?.url;
      if (source) {
        try {
          const imageUrl = new URL(source, location.origin);
          if (imageUrl.protocol === 'https:') {
            imageUrl.searchParams.set('width', '120');
            const img = element('img', 'mmm-sr-img');
            img.src = imageUrl.href; img.alt = ''; img.width = 52; img.height = 64;
            img.loading = 'eager'; img.decoding = 'async'; link.append(img);
          }
        } catch (_) {}
      }
      const info = element('div', 'mmm-sr-info');
      info.append(element('p', 'mmm-sr-title', product.title));
      const price = amount(product.price_min ?? product.price);
      const maximum = amount(product.price_max ?? product.price);
      const reference = amount(product.compare_at_price_min);
      const referenceMax = amount(product.compare_at_price_max);
      if (price != null && formatter) {
        const prices = element('div', 'mmm-sr-price');
        const varies = maximum != null && maximum !== price;
        if (!varies && reference != null && reference === referenceMax && reference > price) {
          prices.append(element('s', 'mmm-sr-compare', formatter.format(reference)));
        }
        prices.append(element('span', 'mmm-sr-current', (varies ? labels[6] + ' ' : '') + formatter.format(price)));
        info.append(prices);
      }
      link.append(info); fragment.append(link);
    });
    fragment.append(allResults(query, labels[2] + ' →'));
    results.replaceChildren(fragment); visible(true);
  }
  input.addEventListener('input', function () {
    clearTimeout(timer); controller?.abort();
    const id = ++requestId, query = input.value.trim();
    results.removeAttribute('aria-busy');
    if (query.length < 2) { results.replaceChildren(); visible(false); return; }
    timer = setTimeout(async function () {
      controller = new AbortController();
      results.replaceChildren(element('div', 'mmm-sr-empty', labels[4]));
      results.setAttribute('aria-busy', 'true'); visible(true);
      try {
        const response = await fetch(route + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide', { signal: controller.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        if (id !== requestId) return;
        render(data.resources?.results?.products || [], query);
      } catch (error) {
        if (id !== requestId || error.name === 'AbortError') return;
        results.replaceChildren(allResults(query, labels[5] + ' →')); visible(true);
      } finally {
        if (id === requestId) results.removeAttribute('aria-busy');
      }
    }, 200);
  });
  input.addEventListener('focus', function () {
    if (input.value.trim().length >= 2 && results.childElementCount) visible(true);
  });
  menu.addEventListener('click', function (event) {
    if (!event.target.closest('#mmm-search-sticky-wrap')) visible(false);
  });
  menu.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && results.style.display !== 'none') {
      event.stopPropagation(); visible(false); input.focus();
    }
  });
})();
